module.exports = __webpack_public_path__ + "static/media/Ikon (2).b98be0b5.svg";